export default "__VITE_ASSET__eff7a927__"